import { Form, Modal, ModalProps } from 'antd';
import React from 'react';
import FinancialClashFlowForm, {
  CashFlowChartFormValues,
} from './FinancialClashFlowForm';

type Props = Omit<ModalProps, 'onOk'> & {
  handleOk: (values: CashFlowChartFormValues) => void;
};

const FinancialClashFlowModal: React.FC<Props> = ({
  open,
  onCancel,
  handleOk,
}) => {
  const [form] = Form.useForm<CashFlowChartFormValues>();

  return (
    <Modal
      title="Filtros do gráfico de Fluxo de Caixa"
      open={open}
      onCancel={onCancel}
      width={600}
      okText="Atualizar Gráfico"
      onOk={async () => {
        try {
          const values = await form.validateFields();
          handleOk({ ...values });
        } catch {}
      }}
    >
      <FinancialClashFlowForm form={form} />
    </Modal>
  );
};

export default FinancialClashFlowModal;
